import type { PackageState } from "../../../store";

export const getSearchFormGuests = (state: PackageState) =>
  state.packages.search.searchFormValues.guests;

export const getSearchFormOrigin = (state: PackageState) =>
  state.packages.search.searchFormValues.origin;

export const getSearchFormDestination = (state: PackageState) =>
  state.packages.search.searchFormValues.destination;

export const getSearchFormDateRange = (state: PackageState) =>
  state.packages.search.searchFormValues.dateRange;

export const getSearchFormRoomCount = (state: PackageState) =>
  state.packages.search.searchFormValues.roomCount;

export const getSearch = (state: PackageState) => state.packages.search.search;

export const getRequestedSearch = (state: PackageState) =>
  state.packages.search.requestedSearch;

export const getSearchFormPackageType = (state: PackageState) =>
  state.packages.search.searchFormValues.packageType;

export const getSearchFormDriverAge = (state: PackageState) =>
  state.packages.search.searchFormValues.driverAge;
